<template>
  <vue-ellipse-progress
    class="mt-5"
    reverse
    :thickness="15"
    emptyThickness="10%"
    :legend="false"
    :data="graphData"
    :gap="7"
    :loading="loading"
  />
</template>

<script>
import { VueEllipseProgress } from "vue-ellipse-progress";

export default {
  components: {
    VueEllipseProgress,
  },
  props: {
    graphData: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
